import { FC } from 'react';

interface Props {
  icon: JSX.Element;
  label: string;
  colorClass: string;
}

export const DiagnosticOnboardingPill: FC<Props> = ({ icon, label, colorClass }) => {
  return (
    <div
      className={`${colorClass} tw-flex tw-items-center tw-rounded-3xl tw-py-2 tw-px-4 `}
      style={{ borderWidth: 2, borderStyle: 'solid' }}
    >
      {icon}
      <span className="tw-font-semibold">{label}</span>
    </div>
  );
};
